import React, { useState } from 'react';
import reunionPhoto from '../../images/davisfamilyreunion2018.jpg';
import familyBanner from '../../images/family-banner-transparent.png';
import shirtMock from '../../images/zoom-mock.png';
import { Calendar, MapPin, Clock, Phone, Mail, Users, Heart, Camera } from 'lucide-react';

export default function FamilyReunionWebsite() {
  const [activeSection, setActiveSection] = useState('home');

  const familyPhotos = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=400&h=300&fit=crop",
      caption: "Last year's reunion - what a blast!"
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1543610892-0b1f7e6d8ac1?w=400&h=300&fit=crop",
      caption: "Grandma's famous apple pie contest"
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=300&fit=crop",
      caption: "Family games in the park"
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=400&h=300&fit=crop",
      caption: "Multi-generational memories"
    }
  ];

  const schedule = [
    { time: "June 12th @ 6pm", event: "Friday Night Banquet", location: "The Lodge at Geneva-on-the-lake (Western Reserve Room)", link: "https://maps.app.goo.gl/s7suiMVEvGJ7RVer5" },
    { time: "June 13th @ 10:30am", event: "Saturday Family Mini-golf", location: "Adventure Zone", link: "https://maps.app.goo.gl/EyXuDXLuKadAYzjk8" },
    { time: "June 13th @ 11:30am", event: "Saturday Free Time! Adventure Zone(zip-lining, go-karts, arcade), Lakeside activities (jetskis, views, bars)", location: "Adventure Zone", link: "https://maps.app.goo.gl/EyXuDXLuKadAYzjk8" },
    { time: "June 13th @ 5pm", event: "Saturday Afternoon Cookout", location: "Geneva Township Park", link: "https://maps.app.goo.gl/9YjNsxcVTpQz2BsA7" },
    { time: "June 14th @ 11am", event: "Sunday [No formal plans] (Farewell!)", location: "The Lodge at Geneva-on-the-lake", link: "https://maps.app.goo.gl/s7suiMVEvGJ7RVer5" },
  /*  { time: "11:00 AM", event: "Family Tree Presentation", location: "Conference Room" },
    { time: "12:30 PM", event: "BBQ Lunch", location: "Picnic Area" },
    { time: "2:00 PM", event: "Kids Activities & Games", location: "Playground" },
    { time: "3:30 PM", event: "Family Talent Show", location: "Main Stage" },
    { time: "5:00 PM", event: "Group Photo Session", location: "Garden Gazebo" },
    { time: "6:00 PM", event: "Dinner & Dancing", location: "Banquet Hall" }*/
  ];

  const NavButton = ({ section, children, icon: Icon }) => (
    <button
      onClick={() => setActiveSection(section)}
      className={`nav-button ${activeSection === section ? 'active' : ''}`}
    >
      <Icon size={20} />
      <span>{children}</span>
    </button>
  );

  return (
    <div style={styles.container}>
      <style>{cssStyles}</style>

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.headerText}>
            <img
                  src={familyBanner}
                  alt="davis family reunion banner"
                  style={{ objectFit: 'cover', width: '60%', height: '100%' }}
            />
            <h1 style={styles.headerTitle}>Davis Family Reunion 2026</h1>
            <p style={styles.headerSubtitle}>Celebrating Family, Creating Memories</p>
            <div style={styles.headerInfo}>
              <div style={styles.headerInfoItem}>
                <Calendar style={styles.headerIcon} />
                <span>June 12-14, 2026</span>
              </div>
              <div style={styles.headerInfoItem}>
                <MapPin style={styles.headerIcon} />
                <span>Geneva-On-The-Lake, Ohio</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navContent}>
          <div style={styles.navButtons}>
            <NavButton section="home" icon={Heart}>Home</NavButton>
            <NavButton section="details" icon={Calendar}>Event Details</NavButton>
            <NavButton section="schedule" icon={Clock}>Schedule</NavButton>
            <NavButton section="lodging" icon={Heart}>Lodging</NavButton>
            {/** <NavButton section="photos" icon={Camera}>Photo Gallery</NavButton>*/}
            <NavButton section="contact" icon={Phone}>Contact & RSVP</NavButton>
            <NavButton section="payment" icon={Heart}>Payment</NavButton>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main style={styles.main}>
        {activeSection === 'home' && (
          <div style={styles.section}>
            {/* Welcome Section */}
            <section style={styles.welcomeSection}>
              <h2 style={styles.sectionTitle}>Welcome to Our Family Reunion!</h2>
              <div style={styles.photoContainer}>
                  <img
                    src={reunionPhoto}
                    alt="picture of the davis family"
                    style={styles.photo}
                  />
              </div>
              <p style={styles.welcomeText}>
                It's time to reconnect, reminisce, and create new memories together! Join us for a weekend filled with
                laughter, delicious food, fun activities, and the warmth that only family can bring.
              </p>
              <div style={styles.featureGrid}>
                <div style={styles.featureCard}>
                  <Users style={styles.featureIcon} />
                  <h3 style={styles.featureTitle}>All Ages Welcome</h3>
                  <p style={styles.featureText}>From the youngest cousins to our beloved elders, everyone's invited!</p>
                </div>
                 <div style={styles.featureCard}>
                  <Heart style={styles.featureIcon} />
                  <h3 style={styles.featureTitle}>Food & Fun</h3>
                  <p style={styles.featureText}>BBQ, games, and good ol' family fun!</p>
                </div>
              </div>
            </section>

            {/* Quick Info */}
            <section style={styles.card}>
              <h3 style={styles.cardTitle}>Quick Details</h3>
              <div style={styles.quickInfoGrid}>
                <div style={styles.quickInfoColumn}>
                  <div style={styles.quickInfoItem}>
                    <Calendar style={styles.quickInfoIcon} />
                    <div>
                      <h4 style={styles.quickInfoLabel}>Date & Time</h4>
                      <p style={styles.quickInfoText}>June 12-14, 2026<br/> </p>
                    </div>
                  </div>
                  <div style={styles.quickInfoItem}>
                    <MapPin style={styles.quickInfoIcon} />
                    <div>
                      <h4 style={styles.quickInfoLabel}>Location</h4>
                      <p style={styles.quickInfoText}>
                      The Lodge at Geneva On The Lake<br />
                      4888 North Broadway (SR 534)<br />
                      Geneva on the Lake, OH 44041 </p>
                    <strong></strong><br />
                    </div>
                  </div>
                </div>
                <div style={styles.quickInfoColumn}>
                  <div style={styles.quickInfoItem}>
                    <Users style={styles.quickInfoIcon} />
                    <div>
                      <h4 style={styles.quickInfoLabel}>What to Bring</h4>
                      <p style={styles.quickInfoText}>Just yourself and your family!</p>
                    </div>
                  </div>
                  <div style={styles.quickInfoItem}>
                    <Heart style={styles.quickInfoIcon} />
                    <div>
                      <h4 style={styles.quickInfoLabel}>RSVP</h4>
                      <p style={styles.quickInfoText}>Please let us know if you're coming by filling out this <a href="https://docs.google.com/forms/d/e/1FAIpQLSfrdX3fUmsxZF0COEhFSAeIIoFyeAqE5cSPc1E-Ok7J7KhfqA/viewform" target="_blank">form!</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}

        {activeSection === 'details' && (
          <div style={styles.section}>
            <section style={styles.card}>
              <h2 style={styles.cardTitle}>Event Details</h2>
              <div style={styles.detailsGrid}>
                <div>
                  <h3 style={styles.detailsSubtitle}>Location Information</h3>
                  <div style={styles.detailsContent}>
                    <p style={styles.detailsAddress}>
                      <strong>The Lodge at Geneva On The Lake</strong><br />
                      4888 North Broadway (SR 534)<br />
                      Geneva on the Lake, OH 44041
                    </p>
                    <p style={styles.detailsText}>
                            The lodge features a banquet hall, outdoor picnic areas, activities,
                            and beautiful views - perfect for our family gathering!
                    <br/><br/>
                      More info at <a href="https://www.thelodgeatgeneva.com/" target="_blank">www.thelodgeatgeneva.com</a>
                    </p>
                    <p style={styles.detailsText}>
                      <strong>Parking:</strong> Free parking available in the main lot and street parking nearby.
                    </p>

                  </div>
                </div>
                <div>
                  <h3 style={styles.detailsSubtitle}>What We're Planning</h3>
                  <ul style={styles.detailsList}>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Friday Night Banquet</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Saturday Afternoon Cookout</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>More details to come soon!</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Cool new reunion shirts!</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <img
                        src={shirtMock}
                        alt="shirt mock"
                        style={{ objectFit: 'cover', width: '70%', height: '70%' }}
                        />
                    </li>
                    {/*<li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Family tree presentation and updates</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Kids' activities and games</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Talent show (come prepared to perform!)</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Professional family photos</span>
                    </li>
                    <li style={styles.detailsListItem}>
                      <span style={styles.bullet}></span>
                      <span>Music and dancing</span>
                    </li>*/}
                  </ul>
                </div>
              </div>
            </section>

            <section style={styles.notesSection}>
              <h3 style={styles.notesTitle}>Important Notes</h3>
              <div style={styles.notesGrid}>
                <div>
                  <h4 style={styles.notesSubtitle}>Food & Dietary Needs</h4>
                  <p style={styles.notesText}>
                    We'll have vegetarian options and can accommodate most dietary restrictions.
                    Please let us know about any special needs when you <a href="https://docs.google.com/forms/d/e/1FAIpQLSfrdX3fUmsxZF0COEhFSAeIIoFyeAqE5cSPc1E-Ok7J7KhfqA/viewform" target="_blank">RSVP.</a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        )}

        {activeSection === 'schedule' && (
          <section style={styles.card}>
            <h2 style={styles.cardTitle}>Schedule of Events</h2>
            <div style={styles.scheduleContainer}>
              {schedule.map((item, index) => (
                <div key={index} style={styles.scheduleItem}>
                  <div style={styles.scheduleTime}>
                    {item.time}
                  </div>
                  <div style={styles.scheduleContent}>
                    <h3 style={styles.scheduleEvent}>{item.event}</h3>
                    <p style={styles.scheduleLocation}>
                      <MapPin style={styles.scheduleLocationIcon} />
                      <a href={item.link} target="_blank">{item.location}</a>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeSection === "lodging" && (
            <section style={styles.card}>
                <div style={styles.section}>
                    <section style={styles.card}>
                      <h2 style={styles.cardTitle}>Lodging Info</h2>
                      <div style={styles.rsvpCard}>
                          <span style={{fontWeight: 'bold'}}>The deadline to book a room is MAY 12TH, 2026</span>
                      </div>
                      <div style={styles.rsvpCard}>
                        <span>The Lodge at Geneva-on-the-Lake offers 109 hotel rooms and suites in a
                        variety of configurations, as well as 25 lakeside Explorer Cottages.<br/><br/> One of the
                         top resorts in Ohio, all Lodge rooms feature complimentary high-speed Internet access,
                         coffee makers, mini-fridges, hairdryers, irons and ironing boards as well as many
                         other convenient amenities.</span>
                         <br/>
                         <br/>
                         <h6> <a href="https://www.thelodgeatgeneva.com/stay/lodging/room-types/#room-types" target="_blank">additional room info</a> </h6>
                      </div>
                      <div style={styles.detailsGrid}>
                        <div>
                          <h3 style={styles.detailsSubtitle}>Pricing</h3>
                            <ul style={styles.detailsList}>
                              <li style={styles.detailsListItem}>
                                <span style={styles.bullet}></span>
                                <span>Premium King or Queen</span>
                              </li>
                              <ul>
                                <li><span><s> $409/night + taxes</s></span></li>
                                <li><span><i style={{color: 'green'}}>family discount rate!: </i><br/> $279/night + 15% taxes</span></li>
                              </ul>
                              <li style={styles.detailsListItem}>
                                <span style={styles.bullet}></span>
                                <span>Courtyard Cottage </span>
                              </li>
                              <ul>
                                  <li><span><s> $609/night + taxes</s></span></li>
                                  <li><span><i style={{color: 'green'}}>family discount rate!: </i><br/> $379/night + 15% taxes</span></li>
                              </ul>
                              <li style={styles.detailsListItem}>
                                <span style={styles.bullet}></span>
                                <span>Premium Cottage</span>
                              </li>
                              <ul>
                                  <li><span><s> $609/night + taxes</s></span></li>
                                  <li><span><i style={{color: 'green'}}>family discount rate!: </i><br/> $399/night + 15% taxes</span></li>
                              </ul>
                            </ul>
                        </div>
                        <div>
                            <h3 style={styles.detailsSubtitle}>Booking Info</h3>
                            <p style={styles.detailsText}>
                              Check your email for booking info!
                              <br/>
                              <br/>
                              If you have not received the email, reach out to
                              Chase Cross-Davis at (919) 757-3122 or chasedavis443@gmail.com
                            </p>
                        </div>
                      </div>
                    </section>
                </div>
            </section>
        )}
        {/*activeSection === 'photos' && (
          <section style={styles.card}>
            <h2 style={styles.cardTitle}>Family Photo Gallery</h2>
            <p style={styles.photoIntro}>
              Here are some memories from previous reunions. Can't wait to add new ones!
            </p>
            <div style={styles.photoGrid}>
              {familyPhotos.map((photo) => (
                <div key={photo.id} style={styles.photoCard}>
                  <div style={styles.photoContainer}>
                    <img
                      src={photo.src}
                      alt={photo.caption}
                      style={styles.photo}
                    />
                    <div style={styles.photoOverlay}>
                      <div style={styles.photoCaption}>
                        <p>{photo.caption}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={styles.photoSubmit}>
              <p style={styles.photoSubmitText}>Want to share your family photos with everyone?</p>
              <button style={styles.photoSubmitButton}>
                Submit Your Photos
              </button>
            </div>
          </section>
        )*/}

        {activeSection === 'contact' && (
          <section style={styles.card}>
            <h2 style={styles.cardTitle}>Contact & RSVP</h2>
            <div style={styles.contactGrid}>
              <div>
                <h3 style={styles.contactSubtitle}>Get in Touch</h3>
                <div style={styles.contactList}>
                  <div style={styles.contactItem}>
                    <div style={styles.contactIcon}>
                      <Phone style={styles.contactIconSvg} />
                    </div>
                    <div>
                      <h4 style={styles.contactLabel}>Call or Text</h4>
                      <p style={styles.contactText}>Chase Cross-Davis: (919) 757-3122</p>
                    </div>
                  </div>
                  <div style={styles.contactItem}>
                    <div style={styles.contactIcon}>
                      <Mail style={styles.contactIconSvg} />
                    </div>
                    <div>
                      <h4 style={styles.contactLabel}>Email</h4>
                      <p style={styles.contactText}>chasedavis443@gmail.com</p>
                    </div>
                  </div>
                  <div style={styles.contactItem}>
                      <div style={styles.contactIcon}>
                        <Mail style={styles.contactIconSvg} />
                      </div>
                      <div>
                        <h4 style={styles.contactLabel}>WhatsApp Family Group Chat</h4>
                      </div>
                  </div>
                </div>
                <div style={styles.committeeCard}>
                  <h4 style={styles.committeeTitle}>Planning Committee</h4>
                  <ul style={styles.committeeList}>
                    <li>Vincent Bennett</li>
                    <li>Chase Cross-Davis</li>
                    <li>Brandon Davis</li>
                    <li>Tasha Davis</li>
                    <li>Amber Dumas</li>
                    <li>Danielle Williams</li>
                    <li>Jasmine Williams</li>
                  </ul>
                </div>
              </div>
              <div>
                <h3 style={styles.contactSubtitle}>RSVP Information</h3>
                <div style={styles.rsvpCard}>
                  <h4 style={styles.rsvpTitle}>Please <a href="https://docs.google.com/forms/d/e/1FAIpQLSfrdX3fUmsxZF0COEhFSAeIIoFyeAqE5cSPc1E-Ok7J7KhfqA/viewform" target="_blank">RSVP</a> ASAP!</h4>
                  <span>This lets us know how many people to plan for :)</span>
                </div>
                <p style={styles.rsvpNote}>
                  <i>Can't wait to see everyone there!</i>
                </p>
              </div>
            </div>
          </section>
        )}
        {activeSection === 'payment' && (
            <section style={styles.card}>
              <h2 style={styles.cardTitle}>Payment</h2>
              <section style={styles.notesSection}>
                    <div>
                      <h4 style={styles.notesSubtitle}>Payment is due Apr 15th, 2026</h4>
                      <p style={styles.notesText}>
                          <b>Adult:</b> $110 <br/>
                          <b>Child(12 and under):</b> $62
                          <br/>
                          <br/>
                          <h4 style={styles.notesSubtitle}>Payment can be made by:</h4>
                          <b>CashApp:</b> $chase443<br/>
                          <b>Venmo:</b> @chase-davis-20<br/>
                          <b>Zelle:</b> 919-757-3122
                          <br/>
                          <br/>
                          <span><i>For non-digital payment methods please contact the committee!</i></span>
                      </p>
                    </div>
              </section>
            </section>
        )}
      </main>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <h3 style={styles.footerTitle}>Davis Family Reunion 2026</h3>
          <p style={styles.footerSubtitle}>
            <Heart style={styles.footerHeart} />
            <span>The Davis Family Tree is fruitful and flourishes
             from marriage, blood, and acts of love</span>
            <Heart style={styles.footerHeart} />
          </p>
        </div>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fef3e2 0%, #fef7ed 50%, #fefce8 100%)',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
  },
  header: {
    background: 'linear-gradient(90deg, #d97706 0%, #ea580c 100%)',
    color: 'white',
    boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '48px 24px'
  },
  headerText: {
    textAlign: 'center'
  },
  headerTitle: {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  headerSubtitle: {
    fontSize: '1.25rem',
    opacity: 0.9
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '16px',
    gap: '24px',
    fontSize: '1.125rem',
    flexWrap: 'wrap'
  },
  headerInfoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  headerIcon: {
    width: '20px',
    height: '20px'
  },
  nav: {
    backgroundColor: 'white',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 50
  },
  navContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '16px 24px'
  },
  navButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    flexWrap: 'wrap'
  },
  main: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '48px 24px'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '48px'
  },
  welcomeSection: {
    textAlign: 'center',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    padding: '48px'
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#b45309',
    marginBottom: '24px'
  },
  welcomeText: {
    fontSize: '1.25rem',
    color: '#374151',
    marginBottom: '32px',
    maxWidth: '800px',
    margin: '0 auto 32px',
    lineHeight: '1.6'
  },
  featureGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '32px',
    marginTop: '40px'
  },
  featureCard: {
    background: 'linear-gradient(135deg, #fef3e2 0%, #fed7aa 100%)',
    padding: '24px',
    borderRadius: '12px'
  },
  featureIcon: {
    width: '48px',
    height: '48px',
    color: '#d97706',
    margin: '0 auto 16px',
    display: 'block'
  },
  featureTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#b45309',
    marginBottom: '8px'
  },
  featureText: {
    color: '#4b5563'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    padding: '32px'
  },
  cardTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#b45309',
    marginBottom: '24px',
    textAlign: 'center'
  },
  quickInfoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '32px'
  },
  quickInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  quickInfoItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px'
  },
  quickInfoIcon: {
    width: '24px',
    height: '24px',
    color: '#d97706',
    marginTop: '4px',
    flexShrink: 0
  },
  quickInfoLabel: {
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '4px'
  },
  quickInfoText: {
    color: '#4b5563',
    margin: 0
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '48px'
  },
  detailsSubtitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#d97706',
    marginBottom: '16px'
  },
  detailsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  detailsAddress: {
    color: '#374151',
    margin: 0
  },
  detailsText: {
    color: '#4b5563',
    margin: 0
  },
  detailsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  detailsListItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    color: '#374151'
  },
  bullet: {
    width: '8px',
    height: '8px',
    backgroundColor: '#f59e0b',
    borderRadius: '50%',
    marginTop: '8px',
    flexShrink: 0
  },
  notesSection: {
    background: 'linear-gradient(90deg, #fef3e2 0%, #fed7aa 100%)',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    padding: '32px'
  },
  notesTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#b45309',
    marginBottom: '16px',
    textAlign: 'center'
  },
  notesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '32px'
  },
  notesSubtitle: {
    fontWeight: '600',
    color: '#d97706',
    marginBottom: '8px'
  },
  notesText: {
    color: '#374151',
    margin: 0
  },
  scheduleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  scheduleItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '24px',
    padding: '16px',
    borderRadius: '12px',
    background: 'linear-gradient(90deg, #fef3e2 0%, #fed7aa 100%)',
    transition: 'all 0.2s',
    cursor: 'pointer'
  },
  scheduleTime: {
    backgroundColor: '#f59e0b',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    minWidth: 'fit-content'
  },
  scheduleContent: {
    flex: 1
  },
  scheduleEvent: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#b45309',
    margin: '0 0 4px 0'
  },
  scheduleLocation: {
    color: '#4b5563',
    display: 'flex',
    alignItems: 'center',
    margin: 0
  },
  scheduleLocationIcon: {
    width: '16px',
    height: '16px',
    marginRight: '4px'
  },
  photoIntro: {
    textAlign: 'center',
    color: '#4b5563',
    marginBottom: '32px',
    fontSize: '1.125rem'
  },
  photoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '24px'
  },
  photoCard: {
    group: true
  },
  photoContainer: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    transition: 'all 0.3s',
    cursor: 'pointer'
  },
  photo: {
    width: '100%',
    height: '450px',
    objectFit: 'cover'
  },
  photoOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0)',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'flex-end'
  },
  photoCaption: {
    padding: '16px',
    color: 'white',
    opacity: 0,
    transition: 'all 0.3s',
    transform: 'translateY(16px)'
  },
  photoSubmit: {
    marginTop: '32px',
    textAlign: 'center'
  },
  photoSubmitText: {
    color: '#4b5563',
    marginBottom: '16px'
  },
  photoSubmitButton: {
    backgroundColor: '#f59e0b',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '8px',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  contactGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '48px'
  },
  contactSubtitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#d97706',
    marginBottom: '24px'
  },
  contactList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  contactIcon: {
    backgroundColor: '#fef3e2',
    padding: '12px',
    borderRadius: '50%'
  },
  contactIconSvg: {
    width: '24px',
    height: '24px',
    color: '#d97706'
  },
  contactLabel: {
    fontWeight: '600',
    color: '#1f2937',
    margin: '0 0 4px 0'
  },
  contactText: {
    color: '#4b5563',
    margin: 0
  },
  committeeCard: {
    marginTop: '32px',
    padding: '24px',
    background: 'linear-gradient(90deg, #fef3e2 0%, #fed7aa 100%)',
    borderRadius: '12px'
  },
  committeeTitle: {
    fontWeight: '600',
    color: '#b45309',
    marginBottom: '8px'
  },
  committeeList: {
    color: '#4b5563',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  rsvpCard: {
    background: 'linear-gradient(90deg, #fef3e2 0%, #fed7aa 100%)',
    padding: '24px',
    borderRadius: '12px',
    marginBottom: '24px'
  },
  rsvpTitle: {
    fontWeight: '600',
    color: '#b45309',
    marginBottom: '8px'
  },
  rsvpText: {
    color: '#374151',
    margin: '0 0 8px 0'
  },
  rsvpList: {
    listStyle: 'disc',
    listStylePosition: 'inside',
    color: '#4b5563',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  rsvpButton: {
    width: '100%',
    backgroundColor: '#f59e0b',
    color: 'white',
    padding: '16px 24px',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '1.125rem',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginBottom: '16px'
  },
  rsvpNote: {
    textAlign: 'center',
    color: '#4b5563',
    margin: 0
  },
  footer: {
    background: 'linear-gradient(90deg, #d97706 0%, #ea580c 100%)',
    color: 'white',
    padding: '32px 0',
    marginTop: '64px'
  },
  footerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px',
    textAlign: 'center'
  },
  footerTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '8px'
  },
  footerSubtitle: {
    opacity: 0.9
  },
  footerLove: {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  footerHeart: {
    width: '20px',
    height: '20px',
    color: '#fde047'
  }
};

const cssStyles = `
  .nav-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.2s;
    border: none;
    cursor: pointer;
    font-weight: 500;
    background-color: white;
    color: #b45309;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .nav-button:hover {
    background-color: #fef3e2;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  .nav-button.active {
    background-color: #f59e0b;
    color: white;
    box-shadow: 0 4px 6px rgba(0,0,0,0.15);
  }

  .photo-container:hover {
    transform: scale(1.05);
    box-shadow: 0 20px 25px rgba(0,0,0,0.15);
  }

  .photo-container:hover .photo-overlay {
    background-color: rgba(0,0,0,0.3);
  }

  .photo-container:hover .photo-caption {
    opacity: 1;
    transform: translateY(0);
  }

  .schedule-item:hover {
    background: linear-gradient(90deg, #fed7aa 0%, #fdba74 100%);
  }

  .photo-submit-button:hover, .rsvp-button:hover {
    background-color: #d97706;
  }

  @media (max-width: 768px) {
    .header-title {
      font-size: 2rem;
    }

    .nav-buttons {
      gap: 8px;
    }

    .nav-button {
      padding: 6px 12px;
      font-size: 0.9rem;
    }

    .feature-grid, .details-grid, .notes-grid, .contact-grid {
      grid-template-columns: 1fr;
    }

    .photo-grid {
      grid-template-columns: 1fr;
    }

    .schedule-item {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;